import { Instagram, Facebook } from "lucide-react";
import { ASSETS, CONTACT } from "@/data/site";
import { openLegal } from "@/components/site/Legal";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Footer = () => {
  return (
    <footer className="bg-charcoal text-cream/80">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src={ASSETS.avatar} alt="Andrea Rauh-Ambros" className="h-12 w-12 rounded-full object-cover object-[50%_25%] ring-1 ring-gold/40" />
            <span>
              <span className="block font-serif text-xl text-cream">Andrea Rauh-Ambros</span>
              <span className="block text-[10px] uppercase tracking-luxe text-gold-soft">Ästhetik & Heilpraktik</span>
            </span>
          </div>
          <p className="mt-5 text-sm leading-relaxed max-w-xs font-light">
            Natürliche Ästhetik und ganzheitliches Wohlbefinden – mit Wissen, Erfahrung und Vertrauen.
          </p>
          <div className="mt-6 flex gap-3">
            {CONTACT.instagram && (
            <a data-testid="footer-instagram" href={CONTACT.instagram} target="_blank" rel="noreferrer" className="h-10 w-10 rounded-full border border-gold/30 flex items-center justify-center hover:bg-gold/10 transition-colors">
              <Instagram size={18} strokeWidth={1.5} className="text-gold-soft" />
            </a>
            )}
            {CONTACT.facebook && (
            <a data-testid="footer-facebook" href={CONTACT.facebook} target="_blank" rel="noreferrer" className="h-10 w-10 rounded-full border border-gold/30 flex items-center justify-center hover:bg-gold/10 transition-colors">
              <Facebook size={18} strokeWidth={1.5} className="text-gold-soft" />
            </a>
            )}
          </div>
        </div>

        <div>
          <h4 className="text-[11px] uppercase tracking-luxe text-gold-soft">Navigation</h4>
          <ul className="mt-5 space-y-3 text-sm">
            {[
              { id: "ueber", label: "Über mich" },
              { id: "leistungen", label: "Leistungen" },
              { id: "galerie", label: "Galerie" },
              { id: "kontakt", label: "Termin vereinbaren" },
            ].map((l) => (
              <li key={l.id}>
                <button data-testid={`footer-link-${l.id}`} onClick={() => scrollTo(l.id)} className="hover:text-cream transition-colors">
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-[11px] uppercase tracking-luxe text-gold-soft">Kontakt</h4>
          <ul className="mt-5 space-y-3 text-sm">
            <li><a href={CONTACT.phoneHref} className="hover:text-cream transition-colors">{CONTACT.phone}</a></li>
            <li><a href={CONTACT.emailHref} className="hover:text-cream transition-colors">{CONTACT.email}</a></li>
            <li>{CONTACT.addressLine1}, {CONTACT.addressLine2}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-cream/10">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-cream/50">
          <p>© {new Date().getFullYear()} Praxis Andrea Rauh-Ambros. Alle Rechte vorbehalten.</p>
          <div className="flex gap-6">
            <button onClick={() => openLegal("impressum")} data-testid="footer-impressum" className="hover:text-cream transition-colors">Impressum</button>
            <button onClick={() => openLegal("datenschutz")} data-testid="footer-datenschutz" className="hover:text-cream transition-colors">Datenschutz</button>
          </div>
        </div>
      </div>
    </footer>
  );
};
